import { Component, OnInit } from '@angular/core';
import { ViewportScroller } from '@angular/common';
@Component({
  selector: 'scf-cookies-policy',
  templateUrl: './cookies-policy.component.html',
  styleUrls: ['./cookies-policy.component.scss'],
})
export class CookiesPolicyComponent implements OnInit {
  displayedColumnsTypeCookies: string[] = ['type', 'description'];
  dataTypeCookies: any[] = [
    {
      type: 'Cookies de sesión',
      description:
        'Son aquellas diseñadas para recabar y almacenar datos mientras el usuario accede a la web para almacenar información que solo interesa conservar durante la prestación del servicio solicitado y desaparecen al terminar la sesión. ',
    },
    {
      type: 'Cookies persistentes',
      description:
        'Son aquellas en las que los datos siguen almacenados en el terminal y pueden ser accedidos y tratados durante un periodo definido por el responsable de la cookie, y que puede ir de unos minutos a varios años. Los plazos de este tipo de cookies se detallan más adelante atendiendo a ',
    },
    {
      type: 'Cookies propias',
      description: 'Son cookies creadas y gestionadas por este sitio web y que solo puede leer el propio sitio web.',
    },
    {
      type: 'Cookies de terceros',
      description:
        'Son aquellas de las que es responsable una entidad distinta de Sabadell Consumer y que, generalmente, se envían al equipo terminal del usuario desde un equipo o dominio que no es gestionado por el banco, sino por otra entidad que trata los datos obtenidos a través de las cookies. Mas detalle sobre terceros en el aparado siguiente.',
    },
  ];
  dataSourceTypeCookies = this.dataTypeCookies;

  displayedColumnsTypeCookies2: string[] = ['purpose', 'description', 'thirdParty'];
  dataTypeCookies2: any[] = [
    {
      purpose: 'Cookies técnicas (siempre activas)',
      description:
        'Son aquellas que permiten al usuario la navegación a través de la web, plataforma o aplicación y la utilización de las diferentes opciones o servicios que en ella existan, permite la gestión y operativa de la página web así como controlar el tráfico y la comunicación de datos, identificar la sesión, acceder a partes de acceso restringido, controlar el fraude vinculado a la seguridad del servicio, utilizar elementos de seguridad durante la navegación, almacenar contenidos para la difusión de vídeos o sonido, habilitar contenidos dinámicos (por ejemplo, animación de carga de un texto o imagen) o compartir contenidos a través de redes sociales.',
      thirdParty:
        '<ul><li><a href="https://www.f5.com/es_es/solutions/use-cases/load-balancing-your-applications" target="_blank">Balanceador F5</a></li><li><a href="https://www.imperva.com/trust-center/cookie-notice/" target="_blank">Imperva</a></li><li><a href="https://www.onetrust.com/es/cookie-policy/" target="_blank">OneTrust</a></li></ul>',
    },
    {
      purpose: 'Cookies analíticas o de medición ',
      description:
        'Son aquellas que permiten al responsable de las mismas el seguimiento y análisis del comportamiento de los usuarios de los sitios web a los que están vinculadas, incluida la cuantificación de los impactos de los anuncios. La información recogida mediante este tipo de cookies se utiliza en la medición de la actividad de los sitios web, aplicación o plataforma, con el fin de introducir mejoras en función del análisis de los datos de uso que hacen los usuarios del servicio',
      thirdParty:
        '<ul><li><a href="https://support.google.com/analytics/answer/11397207?hl=es" target="_blank">Google Analytics</a></li></ul>',
    },
  ];
  dataSourceTypeCookies2 = this.dataTypeCookies2;

  constructor(private scroller: ViewportScroller) {}

  ngOnInit(): void {}

  goFinallyTable() {
    this.scroller.scrollToAnchor('finally');
  }
}
